import React, { useCallback, useEffect } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    Button,
    Grid2 as Grid,
    Link,
    CircularProgress,
} from '@mui/material';
import Passwordbox from '../Shared/PasswordBox';
import { useApi } from '../Api/useApi';
import { AuthRequest, AuthResponse, AuthRycApiClient } from '../Api/ApiServer';
import { useAuthorization } from '../Contexts/Hooks/useAuth';
import { useNavigate } from 'react-router';
import TextFieldMakeAnimationStartHandler from '../Shared/TextFieldMakeAnimationStartHandler';
import { useApiWithCallback } from '../Api/useApiWithCallback';
import ResetPasswordScene from '../Users/ResetPasswordScene';
interface LoginProps {

}

function Login(props: Readonly<LoginProps>) {
    const [username, setUsername] = React.useState('');
    const [password, setPassword] = React.useState('');
    const { unauthorizedApi } = useApi(AuthRycApiClient);
    const [isUserNameAutofilled, setIsUserNameAutofilled] = React.useState(false);
    const [passwordAutoFilled, setPasswordAutoFilled] = React.useState(false);
    const [resetOpen, setResetOpen] = React.useState<boolean>(false);
    const { login, isInitialized, isAuthenticated } = useAuthorization();
    useEffect(() => {
        if (isAuthenticated) {
            // If user is already authenticated, redirect to projects page
            navigate('/logged/projects');
        }
    }, [isAuthenticated]);
    const navigate = useNavigate();
    const { callApiWithCallback } = useApiWithCallback();
    const loginApi = React.useCallback(async () => {
        if (username === "" || password === "") return;
        callApiWithCallback<AuthResponse>(() => unauthorizedApi.login(new AuthRequest({ email: username, password: password })),
            (result) => {
                if (result && result.accessToken && result.refreshToken) {
                    login(result.accessToken, result.refreshToken, result.isAdmin ?? false, result.isSuperAdmin ?? false);
                    navigate('/logged/projects')
                }
            }, '', 'Špatné přihlášení');

    }, [unauthorizedApi, password, username, login, navigate, callApiWithCallback]);

    return (
        <Box >
            {isInitialized && <Box>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: 'calc(100vh - 100px)',
                        backgroundColor: '#f0f2f5',
                        padding: 2,
                        backgroundImage: 'url(/login_background.webp)',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}
                >
                    <Card
                        sx={{
                            maxWidth: 400,
                            width: '100%',
                            padding: 3,
                            boxShadow: 3,
                        }}
                    >
                        <CardContent>
                            <img width={76} style={{ marginBottom: '24px' }} src='/ryc_logo.png' />
                            <Box component="form">
                                <Grid container spacing={2}>
                                    <Grid size={{ xs: 12 }}>
                                        <TextField
                                            fullWidth
                                            slotProps={{
                                                htmlInput: {
                                                    onAnimationStart: TextFieldMakeAnimationStartHandler(setIsUserNameAutofilled),
                                                },
                                                inputLabel: {
                                                    shrink: username !== "" || isUserNameAutofilled
                                                }
                                            }}
                                            label="Email"
                                            variant="outlined"
                                            type="email"
                                            value={username}
                                            onChange={(event) => setUsername(event.target.value)}
                                            required
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <Passwordbox
                                            variant='outlined'
                                            fullWidth
                                            onPasswordAutofilled={() => setPasswordAutoFilled(true)}
                                            password={password}
                                            onPasswordChange={(event: any) => setPassword(event)}
                                            onEnter={() => loginApi()}
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <Link onClick={() => setResetOpen(true)} sx={{ mt: 1 }} color='primary'>{'Zapomenuté heslo'}</Link>
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <Button
                                            fullWidth
                                            disabled={(password === "" || username === "") && (!isUserNameAutofilled && !passwordAutoFilled)}
                                            variant="contained"
                                            color="primary"
                                            size="large"
                                            onClick={loginApi}
                                        >
                                            Login
                                        </Button>
                                    </Grid>
                                </Grid>
                                <ResetPasswordScene open={resetOpen} onClose={() => setResetOpen(false)} />
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
                <Box
                    sx={{
                        width: '100%',
                        height: '100px',
                        backgroundColor: '#e0e0e0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        // justifyContent: 'space-between',
                        position: 'fixed',
                        left: 0,
                        bottom: 0,
                        px: 4,
                        zIndex: 10,
                    }}
                >
                    <Box width={'50%'}>
                        <Typography variant="body1" sx={{ flexGrow: 1 }}>
                            Projekt Inovace 3D projekce a zavedení RIS pro efektivní a bezpečné provedení základů RD (č. OPST_IV_000019_24) je spolufinancován Evropskou unií.
                        </Typography>
                        <Box display='flex' justifyContent='space-between'>

                            <img src="/EU.png" alt="Right Logo" style={{ height: 60 }} />
                            <img src="/MZP.jpg" alt="Left Logo" style={{ height: 60 }} />
                        </Box>
                    </Box>
                </Box>
            </Box>}
            {!isInitialized && <CircularProgress />}
        </Box>
    );
}

export default Login;